import React, { useCallback, useState, useContext } from "react";

import ShiftList from "./ShiftList";
import ShiftItem from "./ShiftItem";
import ErrorModal from "shared/components/UIElements/ErrorModal";
import LoadingSpinner from "shared/components/UIElements/LoadingSpinner";
import { useHttpClient } from "shared/hooks/http-hook";
import { StoreContext } from "shared/context/store-context";
// import { sortShifts } from "shared/util/util";
import "./Admin.css";

const Shift = (props) => {
  const { shifts, storeReady } = useContext(StoreContext);
  const { isLoading, error, clearError } = useHttpClient();
  const [selectedItemId, setSelectedItemId] = useState();
  const [selectedItemShow, setSelectedItemShow] = useState(false);
  const [listShow, setListShow] = useState(true);

  let pageItems = [...shifts];
  // if (props.future) {
  //   pageItems = sortShifts(pageItems);
  // }

  const switchItemView = useCallback(() => {
    setSelectedItemShow(true);
    setListShow(false);
  }, [setSelectedItemShow, setListShow]);

  const ItemSelectHandler = useCallback(
    (itemid) => {
      switchItemView();
      setSelectedItemId(itemid);
    },
    [switchItemView, setSelectedItemId]
  );

  const ItemUpdateHandler = useCallback(
    (itemid) => {
      setSelectedItemId(itemid);
    },
    [setSelectedItemId]
  );

  const switchListView = useCallback(() => {
    setSelectedItemShow(false);
    setListShow(true);
  }, [setSelectedItemShow, setListShow]);

  if (isLoading && !storeReady) {
    return (
      <div className="center">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />
      <div className="adminpageContainer">
        {!isLoading && pageItems && listShow && (
          <div className="liveListContainer">
            <ShiftList items={pageItems} onItemSelect={ItemSelectHandler} />
          </div>
        )}
        {selectedItemId && selectedItemShow && (
          <div className="liveUpdateContainer">
            <ShiftItem
              itemid={selectedItemId}
              currentTime={Date.now()}
              onItemUpdate={ItemUpdateHandler}
              // onClose={ () => setSelectedItemShow(false) }
              onClose={() => switchListView()}
            ></ShiftItem>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default Shift;
